import {AccessType} from '@/features/access-types/types'
import {
    CreatePlannedAccessFormValidationSchema,
    EditPlannedAccessFormValidationSchema
} from '@/features/planned-accesses/formSchemas'
import {AccessFrequency} from '@/features/planned-accesses/types'
import {ProjectSmall} from '@/features/projects/types'
import {TKey} from '@/translations/i18n'

export const accessFrequencyMapToLabel = {
    weekly: 'planned_accesses:weekly',
    monthly: 'planned_accesses:monthly'
} as const satisfies Record<AccessFrequency, TKey>

export const absenceTypesToExclude: AccessType['accessType'][] = [
    'short_extension_processing',
    'short_team_meeting',
    'initial_project_evaluation'
]

export const reportingAccessTypes: AccessType['accessType'][] = ['team_meeting', 'certification']

export const PLANNED_ACCESSES_PSYCHOSOCIAL_THRESHOLD = 7
export const PLANNED_ACCESSES_MEDICAL_THRESHOLD = 8.7

export const calculateTotalElaboration = (
    processingAccesses: {accessType?: AccessType; numberOfAccesses?: number}[]
) => {
    if (processingAccesses.length == 0) return 0
    return processingAccesses.reduce((acc, curr) => {
        return acc + (curr.numberOfAccesses ?? 0)
    }, 0)
}

export const plannedAccessesValuesToPayload = (
    formValues: CreatePlannedAccessFormValidationSchema | EditPlannedAccessFormValidationSchema,
    companySector?: ProjectSmall['sector']
) => {
    return [
        ...formValues.inPersonAccesses
            .filter(access => !!access.accessType?.id)
            .map(access => {
                const sectorValue = formValues.isMixedProject && access.sector ? access.sector : companySector
                return {
                    accessTypeId: access.accessType!.id,
                    frequency: access.frequency,
                    numberOfAccesses: Number(access.numberOfAccesses) || 0,
                    ...(sectorValue && {sector: sectorValue})
                }
            }),
        ...formValues.singleAccesses
            .filter(access => !!access.accessType)
            .map(access => ({
                accessTypeId: access.accessType!.id,
                numberOfAccesses: Number(access.numberOfAccesses) || 0
            })),
        ...formValues.absenceAccesses
            .filter(access => !!access.accessType)
            .map(access => ({
                accessTypeId: access.accessType!.id,
                numberOfAccesses: Number(access.numberOfAccesses) || 0
            }))
    ]
}
